/* eslint-disable tailwindcss/no-custom-classname */
import { Container } from "@/components/molecules/Container";
import { Inner } from "@/components/molecules/Inner";
import Careers from "@/components/organisms/Careers";
import Contact from "@/components/organisms/Contact";
import { TermHead } from "@/components/organisms/TermHead";
import TermNav from "@/components/organisms/TermNav";
import { Footer } from "@/components/templates/Footer";
import { Header } from "@/components/templates/Header";
import Layout from "@/components/templates/Layout";
import Meta from "@/components/templates/Meta";
import { useBudouX } from "@/hooks/useBudouX";

export default function AiPolicyPage(props) {
  const { parse } = useBudouX();
  const isHeaderRelative = true;
  return (
    <>
      <Meta
        pageTitle={"AI活用方針"}
        pageDescription={
          "株式会社トッカシステムズのAI活用方針です。全方位でAIを活用し、社内外にAIの価値を広げ、人間中心のAI活用を推進します。"
        }
        pagePath={"https://tocca.systems/ai_policy/"}
      />
      <Layout>
        <Header isRelative={isHeaderRelative} />
        <main className="flex-1">
          <Container>
            <Inner className="mx-auto box-border flex max-w-6xl flex-col py-10 px-6 text-pri sm:px-8 md:px-12 md:pt-16 md:pb-24">
              <TermNav />
              <div className="order-1 md:order-2">
                <TermHead className="mb-4 md:mb-7">AI活用方針</TermHead>
                <div className="border-x-0 border-t-0 border-b border-solid border-bdc-light px-0 pb-8 text-base text-txt-light md:mb-8 md:px-16 md:pb-8 md:text-md">
                  <p>
                    {parse(
                      "株式会社トッカシステムズは、人間中心主義に基づき、透明性・公平性・倫理性を重視したAI活用を積極的に推進します。"
                    )}
                    <br />
                    {parse(
                      "私たちは、社会の中でリーダーシップを発揮し、責任あるAI活用の模範となることで、持続可能な未来の実現に貢献してまいります。"
                    )}
                  </p>
                  <p>
                    {parse(
                      "以下に、当社のAI活用における基本方針を定めます。"
                    )}
                  </p>
                </div>
                <div className="mx-auto max-w-4xl text-base text-txt-base">
                  <div className="col-auto flex flex-col gap-8">
                    <div className="flex flex-col gap-6">
                      <section>
                        <h3 className="mb-3 text-lg font-bold text-pri md:text-xl">
                          1. 全方位でAIを活用する
                        </h3>
                        <p className="leading-7 md:leading-8">
                          {parse(
                            "AIは一部の業務にとどまらず、すべての業務・すべての案件に活かします。"
                          )}
                          <br />
                          {parse(
                            "開発・営業・バックオフィスまで、全方位でAIネイティブな働き方を推進します。"
                          )}
                        </p>
                      </section>

                      <section>
                        <h3 className="mb-3 text-lg font-bold text-pri md:text-xl">
                          2. 社内だけでなく、社外にもAIの価値を広げる
                        </h3>
                        <p className="leading-7 md:leading-8">
                          {parse(
                            "私たち自身の生産性向上だけでなく、お客様やパートナー、社会全体へAI活用の波を広げます。"
                          )}
                          <br />
                          {parse(
                            "共に進化することで、新たな価値を生み出します。"
                          )}
                        </p>
                      </section>

                      <section>
                        <h3 className="mb-3 text-lg font-bold text-pri md:text-xl">
                          3. AIは目的ではなく「手段」
                        </h3>
                        <p className="leading-7 md:leading-8">
                          {parse(
                            "AI導入そのものが目的ではありません。"
                          )}
                          <br />
                          {parse(
                            "課題を解決し、よりよい成果を生み出すための道具として、最適な形で活用します。"
                          )}
                        </p>
                      </section>

                      <section>
                        <h3 className="mb-3 text-lg font-bold text-pri md:text-xl">
                          4. 人間中心のAI活用
                        </h3>
                        <p className="leading-7 md:leading-8">
                          {parse(
                            "AIは人の仕事を奪うものではなく、人の能力を拡張するものです。"
                          )}
                          <br />
                          {parse(
                            "単純作業をAIに任せることで、人はより創造的で価値ある仕事に集中することができます。"
                          )}
                          <br />
                          {parse(
                            "「人が主役、AIが支える」社会を目指します。"
                          )}
                        </p>
                      </section>

                      <section>
                        <h3 className="mb-3 text-lg font-bold text-pri md:text-xl">
                          5. 責任あるAIの活用
                        </h3>
                        <p className="leading-7 md:leading-8">
                          {parse(
                            "AIの利用には責任が伴います。"
                          )}
                          <br />
                          {parse(
                            "透明性・公平性・倫理性を重視し、社会的信頼を損なわないAI活用を徹底します。"
                          )}
                          <br />
                          {parse(
                            "データの扱いや生成物の影響に配慮し、人にとって安全で、公正なAIの運用を行います。"
                          )}
                        </p>
                      </section>
                    </div>

                    <h4 className="leading-8 md:text-right">
                      制定日: 令和7年10月31日
                      <br />
                      株式会社トッカシステムズ
                      <br />
                      代表取締役社長　谷 樹
                    </h4>
                  </div>
                </div>
              </div>
            </Inner>
          </Container>
        </main>
        <Careers />
        <Contact />
        <Footer />
      </Layout>
    </>
  );
}
